export const removeInvalidPayloadItems = (payload) => {
    if (!payload)
        return;
    const result = Object.entries(payload).reduce((currentPayload, [key, value]) => {
        return (value ? (currentPayload[key] = value, currentPayload) : currentPayload);
    }, {});
    if (Object.keys(result).length === 0)
        return null;
    return result;
};
export const gtmEvent = (payload) => {
    // eslint-disable-next-line no-param-reassign
    const modifiedPayload = removeInvalidPayloadItems(payload);
    if (window.dataLayer && modifiedPayload) {
        window.dataLayer.push(modifiedPayload);
        return payload;
    }
    return null;
};
export const sendNavigationGTMEvent = (payload) => {
    var _a, _b, _c, _d, _e;
    const data = {
        event: 'nav_link_click',
        nav_header: (_a = payload.gtmHeader) === null || _a === void 0 ? void 0 : _a.value,
        link_text: (_b = payload.gtmLabel) === null || _b === void 0 ? void 0 : _b.value,
        link_url: (_d = (_c = payload.url) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.href,
        component_type: (_e = payload.gtmComponentType) === null || _e === void 0 ? void 0 : _e.value
    };
    gtmEvent(data);
};
export const sendCTAGTMEvent = (payload) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const data = {
        event: 'cta_click',
        cta_type: (_a = payload.gtmInteractionType) === null || _a === void 0 ? void 0 : _a.value,
        link_text: (_b = payload.gtmLabel) === null || _b === void 0 ? void 0 : _b.value,
        link_url: (_d = (_c = payload.url) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.href,
        component_type: (_e = payload.gtmComponentType) === null || _e === void 0 ? void 0 : _e.value,
        interaction_type: (_f = payload.gtmInteractionType) === null || _f === void 0 ? void 0 : _f.value,
        cta_placement: (_g = payload.contentAlignment) === null || _g === void 0 ? void 0 : _g.value
    };
    gtmEvent(data);
};
export const sendCarouselGTMEvent = (data) => {
    gtmEvent(data);
};
